// ExactPricingStep.tsx

import {
  BadgeChips,
  GradientImage,
} from "@/Pages/Influencer/LocationChapters/Components/atoms";
import { Button } from "@/shadcnComponents/ui/button";
import { ArrowRight } from "lucide-react";
import { ExactPricingList } from "../../PricingCalculatorHelpers/PriceCalHelpers";

export const ExactPricingStep = ({
  handleStartExtensionFlow,
}: {
  handleStartExtensionFlow: () => void;
}) => (
  <div className="flex  px-[10%] w-full justify-between  items-center gap-10">
    <div className="w-[464px] h-[464px] overflow-hidden rounded-sm ">
      <GradientImage
        image="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/PricingCalcExatct.png"
        altText="Pricing image"
        height={464}
        width={464}
      />
    </div>

    <div className="flex w-[617px] flex-col items-start gap-[52px]">
      <div className="flex flex-col items-start gap-5 self-stretch">
        <BadgeChips
          badge="AUTO MODE"
          icon={"🔥"}
          className=" text-[#FF9900]  bg-[rgba(255,149,0,0.16)] "
        />
        <div className="flex flex-col items-start gap-2.5 self-stretch">
          <span className="text-[color:var(--Shade-White,#FFF)] text-4xl not-italic font-bold leading-[normal] relative ">
            Get a Precise Estimate
            <span className="absolute -top-5 -right-8 animate-bounce ">
              <img
                src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Group.png"
                alt=""
              />
            </span>
          </span>
          <p className="text-[#B6B6B6] text-sm not-italic font-normal leading-7 tracking-[-0.28px]">
            To see a closer, more accurate estimate, here's what you should know
            -
          </p>
          <ul className="text-[#B6B6B6] text-sm not-italic font-normal leading-7 tracking-[-0.28px] list-disc ml-6 ">
            {ExactPricingList?.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
          <br />
          <p className="text-[#B6B6B6] text-sm not-italic font-normal leading-7 tracking-[-0.28px] list-disc ">
            We’re the <b>1st & only platform</b> offering performance-based
            earnings, so you can earn more as your sponsored posts succeed.
          </p>
        </div>
      </div>
      <Button
        onClick={handleStartExtensionFlow}
        className="bg-[#DC2627] gap-2 "
        variant="destructive"
      >
        Install Extension
        <ArrowRight size={16} />
      </Button>
    </div>
  </div>
);
